export enum EContactAlertActions {
    SET_ACTION = '@CONTACT_ALERT/SET_ACTION',
    SET_ENTITY = '@CONTACT_ALERT/SET_ENTITY',
    SET_ALERT_DATA = '@CONTACT_ALERT/SET_ALERT_DATA',
    SET_CONTACT = '@CONTACT_ALERT/SET_CONTACT',
    SET_IS_SHOW_POPUP = '@CONTACT_ALERT/SET_IS_SHOW_POPUP',
    SET_IS_FETCHING_CODE = '@CONTACT_ALERT/SET_IS_FETCHING_CODE',
    SET_IS_VERIFYING_CODE = '@CONTACT_ALERT/SET_IS_VERIFYING_CODE',
    SET_CODE_VERIFICATION_ERROR = '@CONTACT_ALERT/SET_CODE_VERIFICATION_ERROR',
    SET_RESULT = '@CONTACT_ALERT/SET_RESULT',
    RESET_STATE = '@CONTACT_ALERT/RESET_STATE',
}

export type { TResetState } from './resetState';
export { default as resetState } from './resetState';
export type { TSetAction } from './setAction';
export { default as setAction } from './setAction';
export type { IAlertData } from './setAlertData';
export type { TSetAlertData } from './setAlertData';
export { default as setAlertData } from './setAlertData';
export type { TSetCodeVerificationError } from './setCodeVerificationError';
export { default as setCodeVerificationError } from './setCodeVerificationError';
export type { IAlertContact } from './setContact';
export type { TSetContact } from './setContact';
export { default as setContact } from './setContact';
export type { TSetEntity } from './setEntity';
export { default as setEntity } from './setEntity';
export type { TSetIsFetchingCode } from './setIsFetchingCode';
export { default as setIsFetchingCode } from './setIsFetchingCode';
export type { TSetIsShowPopup } from './setIsShowPopup';
export { default as setIsShowPopup } from './setIsShowPopup';
export type { TSetIsVerifyingCode } from './setIsVerifyingCode';
export { default as setIsVerifyingCode } from './setIsVerifyingCode';
export type { IResultState } from './setResult';
export type { TSetResult } from './setResult';
export { default as setResult } from './setResult';
